export const CALENDAR_MIN_YEAR_FROM_NOW = 100;
export const CALENDAR_MAX_YEAR_FROM_NOW = 100;
